<div class="number-step-input"
      [ngClass]="{'number-step-input--readonly': readonly}">

  <div class="number-step-input__label tooltip--reset-top">
    <span class="number-step-input__label__text">{{ fieldConfig.caption | translate }}</span>
    <app-tooltip-icon class="reset-position"
                      *ngIf="tooltipIconVisible"
                      [outlined]="fieldConfig.tooltipIconOutlined"
                      [description]="fieldConfig.description"></app-tooltip-icon>
    <app-information-icon class="information-icon" class="reset-position no-absolute"
                          *ngIf="informationIconVisible"
                          [information]="fieldConfig.predefined.additionalInfo | additionalInfo"
                          [description]="fieldConfig.description | translate">
    </app-information-icon>
  </div>

  <div class="number-step-input__control">

    <button class="number-step-input__control__btn"
            *ngIf="!readonly"
            (click)="decrement()">
      <mat-icon>remove</mat-icon>
    </button>

    <div class="number-step-input__control__input">
      <app-text-field #input
                      *ngIf="!readonly"
                      [bean]="bean"
                      [errorsMap]="errorsMap"
                      [control]="control"
                      [fieldConfig]="fieldConfig"
                      [context]="context"
                      [customMetrics]="customMetrics"
                      (interactiveClick)="emitInteractiveClick()"
      >
      </app-text-field>

      <span class="number-step-input__control__readonly-value"
            *ngIf="readonly">
        {{ readonlyValue }}
      </span>

      <span *ngIf="numberStepInputConfig.inputSuffix"
            class="number-step-input__control__suffix">{{ numberStepInputConfig.inputSuffix | translate }}</span>
    </div>

    <button class="number-step-input__control__btn number-step-input__control__btn--primary"
            *ngIf="!readonly"
            (click)="increment()">
      <mat-icon>add</mat-icon>
    </button>
  </div>

</div>
